import classNames from 'classnames';
import Icon from '/@/components/icon';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const ButtonConsultation = ({
    icon,
    name,
    color = 'orange',
    handleClick,
    selected,
    root50,
}: {
    icon: string;
    name: string;
    color: ['orange', 'blue', 'green', 'green-light', 'brown'];
    handleClick: () => void;
    selected: string;
    root50: bool;
}) => {
    const color2 = settings.app.theme === 'expertobayer' ? 'expertobayer' : color;
    const nameTranslate = _(name);
    const selectedTranslate = _(selected);
    const classNameColor = classNames(styles[`color-${color2}`]);
    const classNameRoot = classNames(
        styles.root,
        selectedTranslate === nameTranslate ? styles[`background-selected-${color2}`] : '',
        root50 ? styles.root50 : styles.root100
    );
    return (
        <div className={classNameRoot} onClick={handleClick}>
            <div className={classNames(styles.iconCircle, classNameColor)}>
                <Icon type={icon} size='xs' className={classNameColor} />
            </div>
            <div className={styles.titleButton}>
                <Title className={styles.title}>{nameTranslate}</Title>
            </div>
        </div>
    );
};

export default ButtonConsultation;
